import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { DropdownList } from '../../common/components/formControls';
import { loadChildrenBySearchTerm, fetchChild } from './actions';
import ui from '../../common/services/ui';

class ChildrenDropdownList extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.handleSearchTermChange = this.handleSearchTermChange.bind(this);

		this.state = {
			searchTerm: '',
			selectedId: null
		};
	}

	componentDidMount() {
		this.searchChildren('');
	}

	searchChildren(searchTerm) {
		this.props.loadChildrenBySearchTerm({ sortKey: 'id', sortDirection: 'asc', pageNumber: 1, pageSize: 20, isDeleted: false, name: searchTerm });
	}

	handleSelectChange(childId) {
		this.setState({ selectedId: childId });

		const { fetchChild, onChange } = this.props;

		if (childId) {
			const { data } = this.getFilteredData();

			if (!data.find(x => x.id === childId)) {
				fetchChild(childId);
			}
		}

		if (onChange) {
			onChange(childId);
		}
	}

	handleSearchTermChange(searchTerm) {
		this.setState({ searchTerm });
		this.searchChildren(searchTerm);
	}

	getFilteredData() {
		const childrenFilter = this.props.childrenBySearchTerm[this.state.searchTerm] || { ids: [], loading: false };
		const data = childrenFilter.ids.map(id => this.props.children[id]);

		if (!childrenFilter.ids.find(x => x === this.state.selectedId)) {
			const selectedChild = this.props.children[this.state.selectedId];
			if (selectedChild) {
				data.push(selectedChild);
			}
		}

		return { data, loading: childrenFilter.loading };
	}

	renderListItem({ item }) {
		return <div>
			<div style={{ fontWeight: 'bold' }}>{item.fullName}</div>
			<div>{ui.formatDate(item.dateOfBirth)} - {ui.formatAge(item.dateOfBirth)}</div>
		</div>;
	}

	renderSelectedItem({ item }){
		return <span>{item.fullName}</span>;
	}

	render() {
		const { name = 'childId', children, childrenBySearchTerm, ...rest } = this.props;

		const { data, loading } = this.getFilteredData();

		return <Field name={name} component={DropdownList}
			options={data} valueField='id' textField='fullName'
			filter busy={loading} clearable
			itemComponent={this.renderListItem}
			valueComponent={this.renderSelectedItem}
			onChange={this.handleSelectChange}
			onSearch={this.handleSearchTermChange}
			{...rest}
		/>;
	}
}

const mapStateToProps = (state) => {
	const { filters, entities: { children } } = state;

	return {
		children,
		childrenBySearchTerm: filters.childrenBySearchTerm
	};
};

ChildrenDropdownList.propTypes = {
	name: PropTypes.string,
	onChange: PropTypes.func
};

export default connect(mapStateToProps, {
	loadChildrenBySearchTerm,
	fetchChild
})(ChildrenDropdownList);